import { gql } from '@urql/core';
import React from 'react';
import Image from 'next/image';
import { getClientEnv } from '../../../client/clientEnv';
import { HighSchoolLocationCardFragment } from '../../../generated/spin-graphql';

gql`
    fragment HighSchoolLocationCard on espin_high_school {
        name
        address {
            state
            city
            country
            location
        }
    }
`;

type Props = {
    highSchool: HighSchoolLocationCardFragment;
};

export const HighSchoolLocationCard: React.FC<Props> = ({ highSchool }) => {
    const { city, state, country, location } = highSchool.address;

    const width = 400;
    const height = 267;

    let buildParams = `center=${encodeURIComponent(`${city},${state},${country}`)}`;
    buildParams += `&zoom=13&size=${width}x${height}&maptype=roadmap`;
    if (!!location?.coordinates) {
        const [longitude, latitude] = location.coordinates;
        buildParams += `&markers=color:red|${latitude},${longitude}`;
    }
    buildParams += `&key=${getClientEnv().NEXT_PUBLIC_MAPS_KEY}`;

    return (
        <div className="profile-card dark-theme">
            <div className="title-container no-pad">
                <h2 className="title">Location</h2>
                <div className="location">
                    <div className="map-wrapper">
                        <Image
                            objectPosition="center"
                            objectFit="cover"
                            layout="fill"
                            src={`https://maps.googleapis.com/maps/api/staticmap?${buildParams}`}
                            alt={`Map of ${highSchool.name}`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
